import apiClient from '../Utils/apiClient';

const MainCompanyController = {
  list: async () => {
    const response = await apiClient.get('main-companies');
    return response.data.data;
  },

  get: async (id) => {
    const response = await apiClient.get(`main-companies/${id}`);
    return response.data.data;
  },

  getCompanies: async (id) => {
    const response = await apiClient.get(`main-companies/${id}/companies`);
    return response.data.data;
  },

  create: async (payload) => {
    const response = await apiClient.post('main-companies', payload);
    return response.data.data;
  },

  update: async (id, payload) => {
    const response = await apiClient.put(`main-companies/${id}`, payload);
    return response.data.data;
  },

  remove: async (id) => {
    const response = await apiClient.delete(`main-companies/${id}`);
    return response.data.data;
  },
};

export default MainCompanyController;
